/* eslint-disable */
var EnvironmentVars = require('environment-vars');

var pathToDotFile = __dirname + '/../../';

module.exports = new EnvironmentVars(pathToDotFile);
